import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, exhaustMap, map } from 'rxjs/operators';
import { AttributeService } from '@modules/shared/services/attribute.service';
import { AttributeActions } from '@store/actions/attribute.actions';
import { UpdateAttributeRequest } from '@models/attribute.model';

@Injectable()
export class AttributeEffects {
  private readonly actions$ = inject(Actions);
  private readonly attributeService = inject(AttributeService);

  getAttributes$ = createEffect(() => this.actions$.pipe(
      ofType(AttributeActions.GET_ATTRIBUTES),
      exhaustMap(({payload}: { payload: string }) => this.attributeService.getAll(payload)
        .pipe(
          map(payload => ({type: AttributeActions.GET_ATTRIBUTES_SUCCESS, payload})),
          catchError(error => of(({type: AttributeActions.GET_ATTRIBUTES_FAILED, error}))),
        )),
    ),
  );

  updateAttribute$ = createEffect(() => this.actions$.pipe(
      ofType(AttributeActions.UPDATE_ATTRIBUTE),
    exhaustMap(({payload}: { payload: UpdateAttributeRequest }) => {
      return this.attributeService.update(payload)
        .pipe(
          map(payload => ({type: AttributeActions.UPDATE_ATTRIBUTE_SUCCESS, payload})),
          catchError(error => of(({type: AttributeActions.UPDATE_ATTRIBUTE_FAILED, error}))),
        )
    }),
    ),
  );

  createAttribute$ = createEffect(() => this.actions$.pipe(
      ofType(AttributeActions.CREATE_ATTRIBUTE),
      exhaustMap(({payload}: { payload: UpdateAttributeRequest }) => this.attributeService.create(payload)
        .pipe(
          map(payload => ({type: AttributeActions.CREATE_ATTRIBUTE_SUCCESS, payload})),
          catchError(error => of(({type: AttributeActions.CREATE_ATTRIBUTE_FAILED, error}))),
        )),
    ),
  );

  deleteAttribute$ = createEffect(() => this.actions$.pipe(
      ofType(AttributeActions.DELETE_ATTRIBUTE),
      exhaustMap(({payload}: {
        payload: { webshopId: string, attributeId: string }
      }) => this.attributeService.delete(payload)
        .pipe(
          map(() => ({type: AttributeActions.DELETE_ATTRIBUTE_SUCCESS, payload: payload.attributeId})),
          catchError(error => of(({type: AttributeActions.DELETE_ATTRIBUTE_FAILED, error}))),
        )),
    ),
  );
}
